import Swiper, { SwiperSlide } from '@/components/common/Swiper';

const Skeleton: React.FC<any> = ({ viewRef }) => {
  return (
    <div className="bg-surface-100-bg my-5" ref={viewRef}>
      <div className="flex justify-between items-center px-5 pt-100">
        <div className="w-48 h-5 bg-surface-200-bg skeleton" />
        <div className="bg-surface-200-bg w-1800 h-7 rounded-full skeleton" />
      </div>
      <div className="bg-surface-200-bg mt-0.5 mx-5 h-4 skeleton" style={{ width: 240 }} />
      <Swiper
        className="h-[140px] mt-4"
        slidesPerView="auto"
        spaceBetween={6}
        slidesOffsetAfter={10}
        slidesOffsetBefore={10}>
        {new Array(6).fill(0).map((_item, index) => {
          return (
            <SwiperSlide className="!w-[98px] pb-1" key={`category-item-skeleton-${index}`}>
              <div className="rounded-400 bg-surface-200-bg skeleton" style={{ width: 98, height: 94 }} />
              <div className="bg-surface-200-bg mt-0.5 px-1 h-4 skeleton" style={{ width: 70 }} />
              <div className="bg-surface-200-bg mt-1 h-4 skeleton" style={{ width: 80 }} />
            </SwiperSlide>
          );
        })}
      </Swiper>
    </div>
  );
};

export default Skeleton;
